import React from 'react'
import Sidenav from './components/Sidenav'
import ContactUs from './components/ContactUs'

export default function Contact() {
  return (
    <> 
    
    <div className="flex  ">
       <div className="">
       <Sidenav />
       </div>
        <div className="mt-16">
            <ContactUs />
        </div>
    </div>
    </>  )
}
